import React, { useEffect } from 'react';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { Select } from 'antd';
import { useShutdownInitiators } from '../../../../../../shared/api/queries/shutdownInitiators';

const { Option } = Select;
const fieldName = fieldNames.mainInitiator;
const cityName = fieldNames.city;
const initiatorsName = fieldNames.initiators;

const MainInitiatorField = ({ form, initialValue, editMode, initCityId }) => {
  const initiators = form.getFieldValue(initiatorsName);
  const cityId = form.getFieldValue(cityName);
  const mainInitiatorValue = form.getFieldValue(fieldName);

  const { data, isFetching } = useShutdownInitiators(cityId, {
    staleTime: Infinity,
    enabled: editMode ? true : Boolean(cityId),
  });

  const options = data?.filter((item) =>
    initiators?.find((init) => init === item.id)
  );

  const isValueByOptions = options?.find(
    (option) => option.id === mainInitiatorValue
  );

  useEffect(() => {
    if (!initiators || initiators?.length === 0) {
      if (form.getFieldValue(fieldName) !== null) {
        form.setFieldsValue({ [fieldName]: null });
      }
      return;
    }

    if (initiators?.length === 1) {
      if (form.getFieldValue(fieldName) !== initiators[0]) {
        form.setFieldsValue({ [fieldName]: initiators[0] });
      }
      return;
    }

    if (!isValueByOptions) {
      if (form.getFieldValue(fieldName) !== null) {
        form.setFieldsValue({ [fieldName]: null });
      }
      return;
    }
  }, [initiators, isValueByOptions]);

  return (
    <Field
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label="Основной инициатор"
      decoratorOptions={{
        initialValue: initialValue,
        rules: [
          {
            required: true,
            message: 'Укажите основного инициатора',
            type: 'number',
          },
        ],
      }}
      fieldProps={{
        placeholder: 'Выберите основного инициатора',
        loading: isFetching,
        mode: 'default',
        optionFilterProp: 'searchtext',
        disabled: Boolean(initiators?.length <= 1),
      }}
      items={options || []}
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
          searchtext={item.name}
        >
          {item.name}
        </Option>
      )}
    />
  );
};

export default MainInitiatorField;
